export default __webpack_public_path__ + "static/media/iso.81db6b94.svg";